import { Tooltip } from "primereact/tooltip";
import { useTranslation } from "react-i18next";

export default function KH1000150008() {
  const { i18n } = useTranslation();

  if (i18n.language === "en") {
    return (
      <>
        <p>
          1. Mr. Neang Vithy
          <span className="vertical-align-super b text-xs text-yellow-500 pl-1">
            (b)
          </span>
          <Tooltip target=".b" position="right" event="both">
            Chairman
          </Tooltip>
        </p>
        <p>
          2. Mrs. Lim Muyly
          <span className="vertical-align-super c text-xs text-yellow-500 pl-1">
            (c)
          </span>
          <Tooltip target=".c" position="right" event="both">
            Executive Director
          </Tooltip>
        </p>
        <p>
          3. Mr. THAI Vantha
          <span className="vertical-align-super d text-xs text-yellow-500 pl-1">
            (d)
          </span>
          <Tooltip target=".d" position="right" event="both">
            Non-Executive Director
          </Tooltip>
        </p>
        <p>
          4. Mr. HUY Vatharo
          <span className="vertical-align-super e text-xs text-yellow-500 pl-1">
            (e)
          </span>
          <Tooltip target=".e" position="right" event="both">
            Independent Director
          </Tooltip>
        </p>
        <p>
          5. Mr. Rami Bashir Asad Sharaf
          <span className="vertical-align-super f text-xs text-yellow-500 pl-1">
            (f)
          </span>
          <Tooltip target=".f" position="right" event="both">
            Non-Executive Director
          </Tooltip>
        </p>
      </>
    );
  }
  return (
    <>
      <p>
        ១. លោក នាង វិធី
        <span className="vertical-align-super b text-xs text-yellow-500 pl-1">
          (b)
        </span>
        <Tooltip target=".b" position="right" event="both">
          ប្រធានក្រុមប្រឹក្សាភិបាល
        </Tooltip>
      </p>
      <p>
        ២. លោកស្រី លឹម មុយលី
        <span className="vertical-align-super c text-xs text-yellow-500 pl-1">
          (c)
        </span>
        <Tooltip target=".c" position="right" event="both">
          អភិបាលប្រតិបត្តិ
        </Tooltip>
      </p>
      <p>
        ៣. លោក ថៃ វ៉ាន់ថា
        <span className="vertical-align-super d text-xs text-yellow-500 pl-1">
          (d)
        </span>
        <Tooltip target=".d" position="right" event="both">
          អភិបាលមិនប្រតិបត្តិ
        </Tooltip>
      </p>
      <p>
        ៤. លោក ហ៊ុន វ៉ាថារ៉ូ
        <span className="vertical-align-super e text-xs text-yellow-500 pl-1">
          (e)
        </span>
        <Tooltip target=".e" position="right" event="both">
          អភិបាលឯករាជ្យ
        </Tooltip>
      </p>
      <p>
        ៥. លោក រ៉ាមីបាស៊ា អាសាត សារាហ្វ
        <span className="vertical-align-super f text-xs text-yellow-500 pl-1">
          (f)
        </span>
        <Tooltip target=".f" position="right" event="both">
          អភិបាលមិនប្រតិបត្តិ
        </Tooltip>
      </p>
    </>
  );
}
